import {Injectable} from '@angular/core';
import {EXTRA_MENU_ITEMS, FAC_MENU_ITEMS, OTHER_MENU_ITEMS} from '../definitions/definitions';
import {MenuItemDefinition} from '../portal/sidebar/menu-item';
import {LocalStorageService} from 'ngx-webstorage';

interface UserNavigations {
    url: string;
    count: number;
    title?: string;
}

@Injectable({
    providedIn: 'root',
})
export class UserTrackerService {
    trackedUrls = this._getLinks([...FAC_MENU_ITEMS, ...OTHER_MENU_ITEMS, ...EXTRA_MENU_ITEMS]);

    constructor(private localStorage: LocalStorageService) {
    }

    private _getLinks(array: MenuItemDefinition[], prev: string[] = []) {
        return array.reduce((previous, current) => {
            if (current.children) {
                this._getLinks(current.children, prev);
            }
            previous.push(current.link);
            return previous;
        }, prev).filter(link => link !== undefined);
    }

    trackNavigation(url: string, userId: number, title: string) {
        url = url.split('?')[0];
        if (title === '404' || title === '403' || url === '/' || !this.trackedUrls.includes(url)) return;
        let navigations: UserNavigations[] = this.localStorage.retrieve((`page-views-${userId}`)) as UserNavigations[];
        if (navigations) {
            const navigation = navigations.find(navUrl => navUrl.url === url);
            if (navigation) {
                navigation.count += 1;
                navigation.title = title;
            } else {
                navigations.push({url, count: 1, title});
            }
        } else {
            navigations = new Array<UserNavigations>({url, count: 1, title});
        }
        this.localStorage.store(`page-views-${userId}`, navigations);
    }

    getCommonlyVisitedPages(userId: number) {
        return (this.localStorage.retrieve((`page-views-${userId}`)) as UserNavigations[])?.sort((a, b) => a.count > b.count ? -1 : 1) || [];
    }

    migrateUserNavigations(userId: number) {
        if (!userId || !localStorage.getItem(`page-views-${userId}`)) return;
        if (!this.localStorage.retrieve(`page-views-${userId}`)) {
            const navigations = (JSON.parse(localStorage.getItem(`page-views-${userId}`)) as UserNavigations[])
                .filter(navigation => this.trackedUrls.includes(navigation.url));
            this.localStorage.store(`page-views-${userId}`, navigations);
        }
        localStorage.removeItem(`page-views-${userId}`);
    }
}
